module.exports = __webpack_public_path__ + "img/475683.b25f6123.png";